/* eslint-disable react/prefer-stateless-function,no-unused-vars */
import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { t } from 'utils/translates';
import {
  selectQueryParams,
  changeQueryParams,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';
import PropTypes from 'prop-types';
import { getValueFromRefDataModules } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

class NotificationsRightSidebar extends Component {
  render() {
    return (
      <div className="page-sidebar-sticky">
        <div className="panel-group page-sidebar-sticky-wrp">
          <div
            aria-multiselectable="true"
            className="panel-group panel-group-side"
            id="panelGroupFilter"
            role="tablist"
          >
            <NavLink
              exact
              className="list-group-item"
              to={{
                pathname: `/notifications`,
                search: this.props.location.search
              }}
            >
              <span className="list-group-item-val text-overflow">
                {t('Все уведомления')}
              </span>
            </NavLink>
            {this.props.eventsUserNoticeTypesCategories.map(item => (
              <NavLink
                key={`eventsUserNoticeTypesCategoriesItem${item.value}`}
                exact
                className="list-group-item"
                to={{
                  pathname: `/notifications/${item.value}`,
                  search: this.props.location.search
                }}
              >
                <span
                  className="list-group-item-val text-overflow"
                  title={item.title}
                >
                  {item.title}
                </span>
              </NavLink>
            ))}
          </div>
        </div>
        <div
          aria-multiselectable="true"
          className="panel-group panel-group-side"
          role="tablist"
        >
          <div className="panel panel-default border-t">
            <div className="panel-body border-t-0">
              <div className="checkbox abc-checkbox abc-checkbox-primary">
                <input
                  id="checkboxOnlyNotReadNotice"
                  type="checkbox"
                  className="styled"
                  checked={
                    this.props.selectQueryParams.notice_app_status === '1'
                  }
                  onClick={() => {
                    this.props.changeQueryParams({
                      page: 1,
                      notice_app_status:
                        this.props.selectQueryParams.notice_app_status === '1'
                          ? ''
                          : '1'
                    });
                    this.props.sendRequest();
                  }}
                />
                <label htmlFor="checkboxOnlyNotReadNotice">
                  {t('Только не прочитанные')}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NotificationsRightSidebar.propTypes = {
  // IN
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired,
  eventsUserNoticeTypesCategories: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  selectQueryParams: PropTypes.shape({
    notice_app_status: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  eventsUserNoticeTypesCategories: getValueFromRefDataModules(
    state,
    'events.typesCategory'
  ),
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NotificationsRightSidebar)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationsList/NotificationsRightSidebar/NotificationsRightSidebar.js